import { IAnalyticsObserver } from './analyticsObserver';
import { NullAnalyticsObservers } from './nullAnalyticsObserver';

export const observer: IAnalyticsObserver = new NullAnalyticsObservers();

export const event = (eventType: string, eventData?: { [key: string]: any }) => observer.event(eventType, eventData);
export const timedEvent = (eventType: string, eventData?: { [key: string]: any }) => observer.timedEvent(eventType, eventData);
export const generateId = () => observer.generateId();
export const getUniqueTime = () => observer.getUniqueTime();
